import { useState } from "react";
import { FilePdf, Trash, DotsSixVertical } from "@phosphor-icons/react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Input } from "@/components/ui/input";

const fileUrl = (gridfsId) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${gridfsId}`;

// Cartão de catálogo arrastável - usado na secção "Gerir Catálogos" para definir a ordem de
// prioridade (drag & drop), refletida na biblioteca pública (/catalogos)
export function SortableCatalogCard({ catalog, onDelete, onRename }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: catalog.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : 'auto',
  };
  const [editing, setEditing] = useState(false);
  const [titleValue, setTitleValue] = useState(catalog.title);

  const saveTitle = () => {
    setEditing(false);
    if (titleValue.trim() && titleValue.trim() !== catalog.title) {
      onRename(catalog.id, titleValue.trim());
    } else {
      setTitleValue(catalog.title);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="group border border-stone-200 rounded-xl overflow-hidden bg-white hover:shadow-lg transition-all duration-200 relative"
      data-testid={`manage-catalogo-${catalog.id}`}
    >
      <button
        {...attributes}
        {...listeners}
        className="absolute top-1.5 left-1.5 z-10 p-1 bg-white/90 rounded-md text-stone-400 hover:text-stone-600 cursor-grab active:cursor-grabbing touch-none"
        data-testid={`drag-handle-catalogo-${catalog.id}`}
      >
        <DotsSixVertical size={16} weight="bold" />
      </button>
      <button
        onClick={() => onDelete(catalog.id)}
        className="absolute top-1.5 right-1.5 z-10 p-1 bg-white/90 rounded-md text-stone-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
        data-testid={`btn-delete-catalogo-${catalog.id}`}
      >
        <Trash size={14} />
      </button>
      <div className="aspect-[3/4] bg-stone-50 flex items-center justify-center overflow-hidden">
        {catalog.cover_gridfs_id ? (
          <img src={fileUrl(catalog.cover_gridfs_id)} alt={catalog.title} className="w-full h-full object-cover" />
        ) : (
          <FilePdf size={56} className="text-red-500" weight="duotone" />
        )}
      </div>
      <div className="p-2.5">
        {editing ? (
          <Input
            autoFocus
            value={titleValue}
            onChange={(e) => setTitleValue(e.target.value)}
            onBlur={saveTitle}
            onKeyDown={(e) => e.key === 'Enter' && saveTitle()}
            className="h-7 text-xs"
            data-testid={`input-rename-catalogo-${catalog.id}`}
          />
        ) : (
          <p
            className="text-xs font-medium text-stone-700 truncate cursor-text hover:text-[#009392]"
            title={`${catalog.title} (clique para editar)`}
            onClick={() => setEditing(true)}
            data-testid={`title-catalogo-${catalog.id}`}
          >
            {catalog.title}
          </p>
        )}
      </div>
    </div>
  );
}
